import { inject, Injectable, Injector } from '@angular/core';
import { WiegungService } from './wiegung-service';
import { Item, Material } from '../types/material';
import { Order } from '../types/order';
import { SOFTLINE_SERVICE_HTTP, Store } from '@softline/core';

@Injectable()
export class MateriallieferscheinretourWiegungService extends WiegungService<Material> {

  readonly type = 'MATERIALLIEFERSCHEIN_RETOUR';
  readonly isMaterialRequired = true;
  readonly isOrderRequired = true;

  constructor() {
    super(inject(SOFTLINE_SERVICE_HTTP), inject(Store), inject(Injector));
    console.log('MateriallieferscheinretourWiegungService');
  }

  weighMaterial(material: Material): void {
  }
}